import { css } from 'styled-components';
import blocks from './blocks';
import collapsible from './collapsible';
import layoutTwoColumns from './layout-two-columns';
import normalize from './normalize';
import overlay from './overlay';
import skeleton from './skeleton';

export default css`
  ${collapsible}
  ${normalize}
  ${overlay}
  /* ${skeleton} */
  /* ${layoutTwoColumns}
  ${blocks} */
`;
